const RecipePlaygroundView = (props) => {
  return null
}

export default RecipePlaygroundView
